import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { setRecoil } from 'recoil-nexus';
import styled from 'styled-components';
import OrderController, {
  KnockOrderItemType,
  KnockOrderType,
  OrderChildType,
  paymentRealmType,
} from '../../../controller/OrderController';
import { fcmSalesCountState, fcmSalesState } from '../../../recoil/fcmMessage';
import {
  APP_NAME_KNOCKKNOCK,
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_WAIT_STATUS,
} from '../../../utils/DataType';
import SalesItem from './SalesItem';
import DatePicker from '../../../components/DatePicker';
import moment from 'moment-timezone';

// order_category 0: 배달, 1: 시간 지정, 2: 퇴실,연박

const SalesManager = () => {
  const messageFlag = useRecoilValue(fcmSalesState);

  //0: 접수대기 , 1:처리중 , 2:완료/취소
  const [status, setStatus] = useState<number>(0);

  //처리중
  const [checkedList, setCheckedList] = useState<KnockOrderItemType[]>([]);
  //완료/취소
  const [completedList, setCompletedList] = useState<KnockOrderItemType[]>([]);
  const [completeStatus, setCompleteStatus] = useState<number>(0);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const [targetDate, setTargetDate] = useState<Date>(new Date());

  const refreshAllOrder = async (isComplete: number) => {
    console.log('refresh');
    if (isComplete >= 1) {
      const oParams = {
        start_date: moment(targetDate).format('YYYY-MM-DD'),
        end_date: moment(targetDate).format('YYYY-MM-DD'),
      };

      let completedOrders = await OrderController.getPosOrderComplete(oParams);
      if (completedOrders) {
        getCompleteOrder(completedOrders);
      }
    }
    if (isComplete <= 1) {
      let orders = await OrderController.getPosOrderNotComplete();
      if (orders) {
        divideOrderList(orders);
      }

      let bHasWaitingOrders: boolean = false;
      if (orders && orders.length > 0) {
        orders.map((order: any) => {
          order.child.map((item: OrderChildType) => {
            if (item.order_status === ORDER_WAIT_STATUS) {
              bHasWaitingOrders = true;
            }
          });
        });
      }
    }
  };

  const getCompleteOrder = (oOrderList: any) => {
    const completedTemp: KnockOrderItemType[] = [];

    if (oOrderList) {
      oOrderList.map((order: KnockOrderType) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          order.child.map((item: OrderChildType) => {
            const orderItem: KnockOrderItemType = {
              app_name: APP_NAME_KNOCKKNOCK,
              store_name: order.store_name,
              order_id: order.order_id,
              parent_store_id: order.parent_store_id,
              store_id: order.store_id,
              table_area_nr: order.table_area_nr,
              table_nr: order.table_nr,
              child: item,
              payment: order.payment
                ? order.payment.filter((iPayment: paymentRealmType) => {
                    return iPayment.order_id === order.order_id;
                  })
                : [],
            };
            completedTemp.push(orderItem);
          });
        }
      });
      setCompletedList([...completedTemp]);
    }
  };

  const divideOrderList = (oOrderList: KnockOrderType[]) => {
    const checkedTemp: KnockOrderItemType[] = [];

    if (oOrderList) {
      oOrderList.map((order) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          order.child.map((item: OrderChildType) => {
            // test
            const orderItem: KnockOrderItemType = {
              app_name: order.app_name,
              store_name: order.store_name,
              order_id: order.order_id,
              parent_store_id: order.parent_store_id,
              store_id: order.store_id,
              table_area_nr: order.table_area_nr,
              table_nr: order.table_nr,
              child: item,
              payment: order.payment
                ? order.payment.filter((iPayment: paymentRealmType) => {
                    return iPayment.order_id === order.order_id;
                  })
                : [],
            };
            checkedTemp.push(orderItem);
          });
        }
      });
    }

    setCheckedList([...checkedTemp]);
  };

  const handleResize = () => {
    if (window.innerWidth > 900) setIsMobile(false);
    else setIsMobile(true);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    refreshAllOrder(1);
    setRecoil(fcmSalesCountState, 0);
  }, [messageFlag]);

  useEffect(() => {
    refreshAllOrder(2);
    setRecoil(fcmSalesCountState, 0);
  }, [targetDate]);

  return (
    <>
      <Style>
        <div className={'contentContainer'}>
          <div className="statusWrap">
            <div
              className={`statusItem ${status === 0 && 'active left'}`}
              onClick={() => setStatus(0)}>
              <h3>진행중</h3>
            </div>
            <div
              className={`statusItem ${status === 1 && 'active right'}`}
              onClick={() => setStatus(1)}>
              <h3>완료</h3>
            </div>
          </div>

          {status === 1 && (
            <div className="dateButtonWrap">
              <DatePicker date={targetDate} setDate={setTargetDate} />
            </div>
          )}

          {/* <div className="orderWrap" onClick={() => setIsOpenBar(false)}> */}
          {/* {status === 1 && (
              <div className="orderTitle">
                <button
                  className={`dateButton ${completeStatus === 0 && 'active'}`}
                  onClick={() => setCompleteStatus(0)}>
                  전체
                </button>
                <button
                  className={`dateButton ${completeStatus === 1 && 'active'}`}
                  onClick={() => setCompleteStatus(1)}>
                  완료
                </button>
                <button
                  className={`dateButton ${completeStatus === 2 && 'active'}`}
                  onClick={() => setCompleteStatus(2)}>
                  취소
                </button>
              </div>
            )} */}
          <RenderOrderList
            checkedList={checkedList}
            completedList={completedList}
            status={status}
            completeStatus={completeStatus}
            isMobile={isMobile}
            refreshAllOrder={refreshAllOrder}
          />
        </div>
      </Style>
    </>
  );
};

const RenderOrderList = (oProps: {
  checkedList: KnockOrderItemType[];
  completedList: KnockOrderItemType[];
  status: number;
  completeStatus: number;
  isMobile: boolean;
  refreshAllOrder: any;
}) => {
  //실제로 화면에 표시될 주문 리스트

  let orderList: KnockOrderItemType[] = [];

  if (oProps.status === 0) {
    //처리중일 경우

    orderList = oProps.checkedList;
  } else if (oProps.status === 1) {
    // 완료/취소일 경우

    if (oProps.completeStatus === 0) {
      //(필터) 전체
      orderList = oProps.completedList;
    } else if (oProps.completeStatus === 1) {
      //(필터) 완료
      orderList = oProps.completedList.filter((order) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          return (
            order.child.order_status === ORDER_COM_STATUS ||
            order.child.order_status === ORDER_COM_DEL_STATUS
          );
        }
        return false;
      });
    } else if (oProps.completeStatus === 2) {
      //(필터) 취소
      orderList = oProps.completedList.filter((order) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          return order.child.order_status === ORDER_CANCLE_STATUS;
        }
        return false;
      });
    }
  }

  return orderList.length === 0 ? (
    <div className="noDataListWrap">
      <div className="titleIcon">
        <img src={`${process.env.PUBLIC_URL}/svg/ic_not_order.svg`} alt="img" />
      </div>
      <div className="title">
        <h3>주문 내역이 없습니다</h3>
      </div>
    </div>
  ) : (
    <div className="dataListWrap">
      {orderList.map((order, index) => {
        if (order.app_name === APP_NAME_KNOCKKNOCK) {
          return (
            <SalesItem
              key={oProps.status + ':' + index}
              order={order}
              isMobile={oProps.isMobile}
              refreshAllOrder={oProps.refreshAllOrder}
            />
          );
        }
      })}
    </div>
  );
};

export default SalesManager;

const Style = styled.div`
  flex: 1;

  /* contentContainer */
  .contentContainer {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0 !important;
    border-radius: 10px;
    overflow: scroll;
  }

  /* statusWrap */
  .statusWrap {
    border-radius: 10px 10px 0 0;
    display: flex;
    background: #ececec;

    .statusItem {
      flex: 1;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      justify-content: center;
      cursor: pointer;
      border-radius: 10px 10px 0 0;
      background: #e5e5e5;

      h3 {
        font-size: 18px;
        line-height: 24px;
        color: #a7a7a7;
        font-weight: 500;
      }

      .newButton {
        border-radius: 50px;
        padding: 2px 12px;
        background: #ff3542;
        margin-top: -44px;

        h5 {
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
        }
      }
    }
    .statusItem.active {
      background: #ffffff;

      h3 {
        color: #333333;
      }
    }
    .left {
      border-radius: 10px 0 0 0;
    }
    .right {
      border-radius: 0 10px 0 0;
    }
  }

  /* orderWrap */
  .orderWrap {
    background: #fff;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    .orderTitle {
      /* position: sticky;
      margin-top: 1%;
      margin-bottom: auto;
      z-index: 3; */
      top: 0;
      position: sticky;
      width: 100%;
      display: flex;
      background: #ffffff;
      align-items: center;
      justify-content: flex-start;
      padding: 8px 0 8px 3vw;
      gap: 6px;
      z-index: 10;

      .dateButton {
        padding: 8px 36px;
        background: #fff;
        border-radius: 5px;
        color: #333333;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        border: 1px solid #999999;
      }
      .dateButton.active {
        background: #333;
        color: #ffffff;
        border: 1px solid #000000;
      }
    }
  }

  .dateButtonWrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px 8%;
  }

  .dataListWrap {
    height: 100%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .noDataListWrap {
    display: flex;
    flex-direction: column;
    height: 70%;
    justify-content: center;
    align-items: center;
    align-self: center;

    .title {
      h3 {
        font-size: 20px;
        line-height: 24px;
        color: #999999;
        font-weight: 500;
      }
    }
    .titleIcon {
      clear: both;
    }
  }

  @media (max-width: 900px) {
    .statusWrap {
      margin: 0 10px;
      border-radius: 50px;
      display: flex;
      background: #f7f7f7;
      border: 1px solid #e5e5e5;

      .statusItem {
        flex: 1;
        padding: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        justify-content: center;
        cursor: pointer;
        border-radius: 50px;
        background: #f7f7f7;
        h3 {
          font-size: 22px;
          color: #a7a7a7;
          font-weight: 600;
        }

        .newButton {
          border-radius: 50px;
          padding: 2px 12px;
          background: #ff3542;
          margin-top: -44px;

          h5 {
            font-weight: 500;
            line-height: 20px;
            color: #ffffff;
          }
        }
      }
      .statusItem.active {
        padding: 13px;
        border: 5px solid #f7f7f7;
        background: #ffb53a;
        h3 {
          color: #ffffff;
        }
      }
    }

    .dateButtonWrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 10px 10px 6px 10px;
    }

    .dataListWrap {
      padding-top: 10px;
      height: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
`;
